/**
 * Le pasamos un listado de acciones y le mandamos el nombre de la accion que queremos buscar para validar si existe
 * @param actions string[]
 * @param actionName string
 * @returns string | undefined
 */
export const getActionService = (actions: string[], actionName: string) => {
    const action = actions.find((action) => action === actionName);

    return action;
};
